module.exports = __webpack_public_path__ + "fonts/SourceSansPro-SemiBoldItalic.40000185.ttf";